<script setup lang="ts">
import {useElementHover} from '@vueuse/core';
import {computed, ref} from 'vue';
import {useStore} from '../store';

const props = defineProps<{
    index: number;
    image: string;
}>();

const store = useStore();
const elRef = ref<HTMLElement | undefined>();

const isHover = useElementHover(elRef);
const isActive = computed(() => store.currentIndex === props.index);
</script>

<template>
    <div
        ref="elRef"
        :class="['gallery-thumb', {'is-hover': isHover, 'is-active': isActive}]"
        :style="{'background-image': `url(${image})`}"
        @click="store.showImage(index)"
    />
</template>
